import { G as m, I as f, T as d } from "./TrackedEventData-27d5e534.js";
let i;
const e = import(`${window.location.origin}/common/scripts/tracking/TrackingManager.js`).then((n) => i = n.TrackingManager.getInstance());
function a(n) {
  i === void 0 ? e.then((t) => n(t)) : n(i);
}
function c(n) {
  return i === void 0 ? e.then((t) => t.initialize(n)) : i.initialize(n);
}
function o(n) {
  a((t) => t.trackSharingEvent(n));
}
function g(n) {
  a((t) => t.trackSignedEvent(n));
}
function s(n) {
  a((t) => t.submitTrackedEvent(n));
}
function v(n) {
  a((t) => t.submitInternalEvent(n));
}
function k(n) {
  a((t) => t.submitGAEvent(n));
}
function u(n, t) {
  a(
    (r) => r.trackContractSection(n, t)
  );
}
export {
  m as GaEventData,
  f as InternalEventData,
  d as TrackedEventData,
  c as initializeTracking,
  k as submitGAEvent,
  v as submitInternalEvent,
  s as submitTrackedEvent,
  u as trackContractSection,
  o as trackSharingEvent,
  g as trackSignedEvent
};
//# sourceMappingURL=index.js.map
